import { apiSlice } from 'src/app/redux/api/apiSlice';
import { CreateLabelType, GetLabelsResultType, UpdateLabelType } from 'src/app/services/labels/labels-service.type';
import { finalUrlsConfig } from 'src/configs/url.config';
import { LabelType } from 'src/types/labels.type';
import { LookupDataType } from 'src/types/query.type';

export const labelSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLabels: builder.query<GetLabelsResultType, LookupDataType | void>({
      query: () => ({
        url: finalUrlsConfig().labels.lookup,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'Labels' as const,
                id,
              })),
              { type: 'Labels', id: 'LIST' },
            ]
          : [{ type: 'Labels', id: 'LIST' }],
    }),
    createLabel: builder.mutation<LabelType, CreateLabelType>({
      query: (data) => ({
        url: finalUrlsConfig().labels.update,
        body: data,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Labels', id: 'LIST' }],
    }),
    updateLabel: builder.mutation<LabelType, UpdateLabelType>({
      query: (data) => ({
        url: finalUrlsConfig().labels.update,
        body: data,
        method: 'PATCH',
      }),
      invalidatesTags: (_result, _error, data) => [{ type: 'Labels', id: data.id }],
    }),
    deleteLabel: builder.mutation<void, string>({
      query: (id: string) => ({
        url: `${finalUrlsConfig().labels.delete}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [{ type: 'Labels', id }],
    }),
  }),
});

export const { useGetLabelsQuery, useCreateLabelMutation, useUpdateLabelMutation, useDeleteLabelMutation } = labelSlice;
